export enum DocsVerificationTabEnum {
    PERSONAL_DATA = 'PERSONAL_DATA',
    DOCUMENT = 'DOCUMENT',
    BIOMETRICS = 'BIOMETRICS',
    ADDRESS = 'ADDRESS',
}

export enum DocsVerificationInternalTabEnum {
    KYB = 'KYB',
    DEVICE_FINGERPRINTING = 'DEVICE_FINGERPRINTING',
}
